module.exports = __webpack_public_path__ + "img/multi-media-video-icon.c4aa3fde.png";